
















import RecessAPI from '@services/RecessAPI'

export default
  name: 'Upload'
  props: ['event']
  data: ->
    isDragging: false
    isUploading: false
    isUploaded: false
    uploadedImage: null
    timer: null
  computed:
    bgUrl: ->
      image = @event.ctx?.images?[0]
      url = image?.hero_url || image?.url
      url = @uploadedImage if @uploadedImage?
      url
    dropboxClasses: ->
      'bg-success' : @isUploading
      'hover:border-success' : !@isUploading
      'bg-cover' : @bgUrl?
    dropboxStyle: ->
      {'background-image' : "url(#{@bgUrl})"}
    dropzoneClasses: ->
      'visible opacity-100 bg-success-glass' : @isDragging
      'invisible opacity-0' : !@isDragging
  methods: 
    emitFile: (file) -> @handleFile(file)
    handleDropzoneClicked: -> @$refs.uploadInput.click()
    handleDropzoneUpload: ->
      @isUploading = true
      file = this.$refs.uploadInput.files[0]
      @handleFile file
    handleFile: (file) ->
      try
        @isUploaded = false
        @uploadedImage = (await RecessAPI.uploadEventPhoto(@$route.params.eventId, file)).photo.url
        @isUploading = false
        @isUploaded = true
      catch 
    removePhotoClicked: -> 
      @isUploaded = false
      @uploadedImage = ''
  mounted: ->
    @isUploaded = @event.ctx?.images?.length
    timer = null
    dropzone = document.getElementById('dropzone')
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach (eventName) ->
      window.addEventListener eventName, (event) ->
        event.preventDefault()
      , false
    window.addEventListener 'dragover', (event) =>
      data = event.dataTransfer
      if data.types? && data.types.includes 'Files'
        @isDragging = true
        clearTimeout(@timer)
    , false
    window.addEventListener 'dragleave', (event) =>
      timer = setTimeout => 
        @isDragging = false 
      , 25 
    , false
    window.addEventListener 'drop', (event) =>
      data = event.dataTransfer
      files = Array.from data.files 
      if files[0] and ['image/gif', 'image/jpeg', 'image/png'].includes files[0]?.type
        @emitFile(files[0]) 
        @isUploading = true
      @isDragging = false
    , false
